var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("v-tour", {
        attrs: {
          name: "spider-detail",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "div",
        { staticClass: "selector" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Spider")) + ": ")
          ]),
          _c(
            "el-select",
            {
              attrs: { id: "spider-select" },
              on: { change: _vm.onSpiderChange },
              model: {
                value: _vm.spiderForm._id,
                callback: function($$v) {
                  _vm.$set(_vm.spiderForm, "_id", $$v)
                },
                expression: "spiderForm._id"
              }
            },
            _vm._l(_vm.allSpiderList, function(op) {
              return _c("el-option", {
                key: op._id,
                attrs: { value: op._id, label: op.name }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.onTabClick },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Overview"), name: "overview" } },
            [_c("spider-overview")],
            1
          ),
          _vm.isGit
            ? _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("Git"), name: "git-settings" } },
                [_c("git-settings")],
                1
              )
            : _vm._e(),
          _vm.isScrapy
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Scrapy Settings"),
                    name: "scrapy-settings"
                  }
                },
                [
                  _c("spider-scrapy", {
                    on: {
                      "click-spider": _vm.onClickScrapySpider,
                      "click-pipeline": _vm.onClickScrapyPipeline
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isConfigurable
            ? _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("Config"), name: "config" } },
                [
                  _c("config-list", {
                    ref: "config",
                    on: { convert: _vm.onConvert }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Files"), name: "files" } },
            [_c("file-list", { ref: "file-list" })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Environment"), name: "environment" } },
            [_c("environment-list")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Analytics"), name: "analytics" } },
            [_c("spider-stats", { ref: "spider-stats" })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Schedules"), name: "schedules" } },
            [_c("spider-schedules")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }